<mat-nav-list>
  <img class="logo" src="./../../../../assets/logo.svg" alt="logo" />

  @for (item of visibleMainMenuItemsBeforeTeam$ | async; track item.routerLink) {
    <mat-list-item [routerLink]="item.routerLink" [routerLinkActive]="['active-link']">
      <span class="menu-item">
        @if (item.icon) {
          <mat-icon [svgIcon]="item.icon"></mat-icon>
        }
        <span class="full-width"> {{ item.labelKey | transloco }}</span>
      </span>
    </mat-list-item>
  }

  @if (visibleTeamMenuItems$ | async; as teamMenuItems) {
    @if (teamMenuItems.length) {
      <div class="team-menu">
        <mat-list-item class="team-menu__heading">
          <span class="menu-item">
            <mat-icon svgIcon="person"></mat-icon>
            <span class="full-width">{{ 'menu.team' | transloco }}</span>
          </span>
        </mat-list-item>
        @for (teamItem of teamMenuItems; track teamItem.routerLink) {
          <mat-list-item
            [class]="teamItem.cssClass"
            [routerLink]="teamItem.routerLink"
            [routerLinkActive]="['active-link']"
          >
            <span class="menu-item">
              <span class="full-width">{{ teamItem.labelKey | transloco }}</span>
            </span>
          </mat-list-item>
        }
      </div>
    }
  }

  @for (item of visibleMainMenuItemsAfterTeam$ | async; track item.routerLink) {
    <mat-list-item [routerLink]="item.routerLink" [routerLinkActive]="['active-link']">
      <span class="menu-item">
        @if (item.icon) {
          <mat-icon [svgIcon]="item.icon"></mat-icon>
        }
        <span class="full-width"> {{ item.labelKey | transloco }}</span>
      </span>
    </mat-list-item>
  }

  <div class="languages" *ngIf="activeLang">
    <p-splitButton class="split-btn" [model]="langBtnMenuItems">
      <ng-template pTemplate="content">
        <span class="flex items-center font-bold">
          <mat-icon matSuffix class="globe" svgIcon="language"></mat-icon>
          <span>{{ 'language.' + activeLang | transloco }}</span>
        </span>
      </ng-template>
    </p-splitButton>
  </div>

  <div class="auth" *let="isUser$ | async as user">
    <p class="acc-name">{{ user?.name }}</p>
    <app-button
      *ngIf="user || greenAuthUser || accessRestricted"
      icon="logout"
      [type]="btnTypes.Stroked"
      [size]="btnSizes.FullWidth"
      [label]="'buttons.logout' | transloco"
      (onClick)="logout()"
    ></app-button>
  </div>
</mat-nav-list>
